import type React from 'react';

function OngoingIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 560.66 560.66" {...props}>
      <title>Ongoing Icon</title>

      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1-2">
          <g id="Lager_2-2" data-name="Lager 2">
            <g id="Lager_1-2" data-name="Lager 1-2">
              <path
                d="M470.39,208.52c-31.71,0-56.46,9.47-74.83,28.62h-.77v-23.98h-40.79v192.18h42.73v-132.43c16.83-17.79,36.34-26.29,59.54-26.29,36.55,0,55.69,17.21,55.69,59.16v99.57h42.73v-109.82c0-58-32.48-87-84.29-87Z"
                fill="currentColor"
              />
              <path
                d="M272.61,167.73c-27.84-25.13-65.55-37.7-112.13-37.7s-84.69,12.57-112.52,37.7c-27.84,25.13-41.96,59.16-41.96,102.28s14.11,77.33,41.96,102.47c27.84,24.94,65.34,37.51,112.52,37.51s84.29-12.57,112.13-37.51c27.84-25.13,41.96-59.35,41.96-102.47s-14.12-77.15-41.96-102.28Zm-32.68,176.51c-19.91,17.98-46.6,27.07-79.47,27.07s-60.12-9.09-80.05-27.07c-19.91-18.56-30.16-43.11-30.16-74.24s10.25-55.67,30.16-73.66c19.91-18.37,46.6-27.46,80.05-27.46s59.54,9.09,79.47,27.46c20.11,17.98,30.16,42.73,30.16,73.66s-10.05,55.69-30.16,74.24Z"
                fill="currentColor"
              />
            </g>
          </g>
        </g>
        <rect width="560.66" height="560.66" fill="none" />
      </g>
    </svg>
  );
}

export default OngoingIcon;
